module.exports = __webpack_public_path__ + "static/media/details-1.a776ed8f.jpeg";